export const iconSvg = (id, classes, alt) => {
	const className = `icon icon-${id}${classes ? ` ${classes}` : ''}`;
	const aria = alt ? `role="img" aria-label="${alt}"` : 'aria-hidden="true"';

	return `<span class="${className}" ${aria}></span>`;
};
